import {POSTERMYWALL_ICON_VECTOR_TYPE} from '@FormMakerReact/components/postermywall-icon-vector/postermywall-icon-vector';
import {registerRightPanelSector} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';
import {IconVectorBgColorControl} from './components/icon-vector-bg-color-control/icon-vector-bg-color-control';
import {IconVectorTickColorControl} from './components/icon-vector-tick-color-control/icon-vector-tick-color-control';

registerRightPanelSector(POSTERMYWALL_ICON_VECTOR_TYPE, {
  title: window.i18next.t('pmwjs_checkmark'),
  controls: [IconVectorBgColorControl, IconVectorTickColorControl],
});
